import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import cn from 'classnames';
import { Kebab } from '../../icons';
import { Button } from '../Button';
import { useDevice } from '../Device';
import { DropdownMenu } from '../DropdownMenu';
import { IconButton } from '../IconButton';
import { TableList, useTableListRowContext } from '../TableList';
import styles from './TableListActions.module.scss';
/**
 * Composite component used in tables as the last column that shows actions to be
 * performed on the row. Will only show itself when the row is hovered or when the
 * dropdown is opened.
 */ export function TableListActions(props) {
    var _bi_menuTrigger;
    const { buttonText, buttonIntent, buttonIcon, secondaryButtonText, secondaryButtonIcon, children, testId, btnHeapId, secondaryBtnHeapId, menuHeapId, onClickButton, onClickSecondaryButton, mobile, bi, noBi: _noBi } = props;
    const { setForceHover, size } = useTableListRowContext();
    const { isMobileDevice } = useDevice();
    const [isOpen, setIsOpen] = useState(false);
    const secondaryButtonBiProps = bi ? bi.secondaryButton ? {
        bi: bi.secondaryButton
    } : {
        noBi: true
    } : {
        noBi: _noBi
    };
    const mobileButtonMenuItem = isMobileDevice && buttonText && /*#__PURE__*/ _jsx(DropdownMenu.Item, _object_spread_props(_object_spread({}, bi ? {
        bi: bi.button
    } : {
        noBi: _noBi
    }), {
        testId: testId && "".concat(testId, "-mobile-button-menu-item"),
        onClick: (e)=>onClickButton === null || onClickButton === void 0 ? void 0 : onClickButton(e),
        iconStart: buttonIcon,
        children: buttonText
    }));
    const mobileSecondaryButtonMenuItem = isMobileDevice && secondaryButtonText && /*#__PURE__*/ _jsx(DropdownMenu.Item, _object_spread_props(_object_spread({}, secondaryButtonBiProps), {
        testId: testId && "".concat(testId, "-mobile-secondary-button-menu-item"),
        onClick: (e)=>onClickSecondaryButton === null || onClickSecondaryButton === void 0 ? void 0 : onClickSecondaryButton(e),
        iconStart: secondaryButtonIcon,
        children: secondaryButtonText
    }));
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": testId && "".concat(testId, "-action-root"),
        className: cn(styles.actionsWrapper, {
            [TableList.classes.showAlways]: isOpen
        }),
        onClick: (e)=>{
            e.stopPropagation();
            e.preventDefault(); //to prevent full page navigation when wrapped in an "a" tag
        },
        children: [
            !isMobileDevice && (buttonText || secondaryButtonText) && /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.buttonsWrapper, TableList.classes.showOnRowHover, {
                    [styles.withoutDropdown]: !children,
                    [TableList.classes.showAlways]: isOpen
                }),
                children: [
                    buttonText && /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, bi ? {
                        bi: bi.button
                    } : {
                        noBi: _noBi
                    }), {
                        noWrap: true,
                        intent: buttonIntent,
                        size: size !== 'large' ? 'small' : 'medium',
                        onClick: onClickButton,
                        testId: testId && "".concat(testId, "-btn"),
                        "data-heapid": btnHeapId,
                        children: buttonText
                    })),
                    secondaryButtonText && /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, secondaryButtonBiProps), {
                        noWrap: true,
                        skin: "primaryOutline",
                        className: styles.secondaryBtn,
                        size: size !== 'large' ? 'small' : 'medium',
                        onClick: onClickSecondaryButton,
                        testId: testId && "".concat(testId, "-secondary-btn"),
                        "data-heapid": secondaryBtnHeapId,
                        children: secondaryButtonText
                    }))
                ]
            }),
            children || mobileButtonMenuItem || mobileSecondaryButtonMenuItem ? /*#__PURE__*/ _jsxs(DropdownMenu, {
                mobile: mobile,
                onOpenChange: (open)=>{
                    setIsOpen(open);
                    setForceHover(open);
                },
                onClose: (anchorEl, reason)=>{
                    if (reason === 'backdropClick') {
                        // Manually blur the anchorEl to prevent it from staying visible on a non-hovered row.
                        requestAnimationFrame(()=>{
                            anchorEl && anchorEl.blur();
                        });
                    }
                },
                target: /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({}, bi ? {
                    bi: (_bi_menuTrigger = bi.menuTrigger) !== null && _bi_menuTrigger !== void 0 ? _bi_menuTrigger : {
                        name: 'actions_menu'
                    }
                } : {
                    noBi: _noBi
                }), {
                    size: isMobileDevice ? 'smallMedium' : 'medium',
                    noPadding: isMobileDevice,
                    testId: testId && "".concat(testId, "-dropdown-trigger"),
                    "data-heapid": menuHeapId,
                    children: /*#__PURE__*/ _jsx(Kebab, {})
                })),
                testId: "".concat(testId, "-dropdown"),
                children: [
                    mobileButtonMenuItem,
                    mobileSecondaryButtonMenuItem,
                    children
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                "data-testid": testId && "".concat(testId, "-dropdown-placeholder"),
                className: styles.hiddenDropdown
            })
        ]
    });
}
